import Pqp from "../../3x1010/Pqp";
import Game from "../Game";
import Item from "../items/Item";
import ItemIniter from "../items/ItemIniter";
import ItemProviders from "../items/ItemProviders";
import Skills from "../screen/skills/Skills";
import DungeonMaster from "./DungeonMaster";
import Player from "./Player";

export default class Bout {
	constructor(itemAtlas, cfg, mobcfg, savegame = null) {
		Bout.that = this;
		this.itemAtlas = itemAtlas;
		this.items = itemAtlas.assets;
		this.savegame = savegame;
		this.data = new Object();
		this.player = null;
		this.levelChests = new Array();
		this.cfg = cfg;
		this.mobcfg = mobcfg;
	}
	init() {
		this.data.inventory = new Array();
		this.data.paperdoll = new Array();
		this.data.variables = new Object()
		this.data.statistics = new Object()
		this.dm = new DungeonMaster(this.cfg, this.mobcfg);

		//let tmp;
		if (this.savegame) {
			//tmp = this.getItemsFromSave();
			this.fillInventoryFromSave(this.savegame.state.inventory);
			this.fillPaperdollFromSave(this.savegame.state.paperdoll);
			this.setStateVariables(this.savegame.state.variables);
			this.setStatistics(this.savegame.state.statistics);
			this.restorePlayerStats()
		} else {
			let tmp = this.getStartingItems();
			this.setPlayerStats()
			this.fillInventoryFromStart(tmp);
			this.fillPaperdollFromStart(tmp);
			//this.setStateVariables(Bout.DEFAULT_STATE_VARIABLES);
		}
		this.data.player = this.player;

		this.normalizeItemPool()

	}

	setStateVariables(o) {
		this.data.variables = JSON.parse(JSON.stringify(o));
	}

	setStatistics(o) {
		this.data.statistics = JSON.parse(JSON.stringify(o));
	}

	static gv(name) {
		let values = Bout.that.data.variables;
		if (values[name]) {
			return values[name]
		} else {
			values[name] = false;
		}
		return values[name];
	}
	static sv(name, value) {
		let values = Bout.that.data.variables;
		values[name] = value;
	}


	static setStatistic(name, value) {
		Bout.that.data.statistics[name] = value;
		//Bout.printStatistics();
	}
	static incStatistic(name, value) {
		let val = Bout.that.data.statistics[name];
		if (!val) {
			Bout.that.data.statistics[name] = 0;
		}
		Bout.that.data.statistics[name] += value;
		//Bout.printStatistics();
	}
	static getStatistic(name) {
		let val = Bout.that.data.statistics[name];
		if (!val) {
			Bout.that.data.statistics[name] = 0;
		}
		return Bout.that.data.statistics[name];
	}
	static printStatistics() {
		console.log(" ");
		console.log(Bout.STAT_START_TIME, Bout.that.data.statistics[Bout.STAT_START_TIME]);
		console.log(Bout.STAT_END_TIME, Bout.that.data.statistics[Bout.STAT_END_TIME]);
		console.log(Bout.STAT_HITS, Bout.that.data.statistics[Bout.STAT_HITS]);
		console.log(Bout.STAT_HITS_CRITICAL, Bout.that.data.statistics[Bout.STAT_HITS_CRITICAL]);
		console.log(Bout.STAT_ATTACKS, Bout.that.data.statistics[Bout.STAT_ATTACKS]);
		console.log(Bout.STAT_TOTAL_DAMAGE, Bout.that.data.statistics[Bout.STAT_TOTAL_DAMAGE]);
		console.log(Bout.STAT_MAX_DAMAGE, Bout.that.data.statistics[Bout.STAT_MAX_DAMAGE]);
		console.log(Bout.STAT_DAMAGE_SUFFERED, Bout.that.data.statistics[Bout.STAT_DAMAGE_SUFFERED]);
		console.log(Bout.STAT_PARRIED, Bout.that.data.statistics[Bout.STAT_PARRIED]);
		console.log(Bout.STAT_ENEMIES_KILLED, Bout.that.data.statistics[Bout.STAT_ENEMIES_KILLED]);
		console.log(Bout.STAT_HERO_DEATHS, Bout.that.data.statistics[Bout.STAT_HERO_DEATHS]);
		console.log(Bout.STAT_ENCOUNTER_AMBUSH, Bout.that.data.statistics[Bout.STAT_ENCOUNTER_AMBUSH]);
		console.log(Bout.STAT_ENCOUNTER_SURPRISE, Bout.that.data.statistics[Bout.STAT_ENCOUNTER_SURPRISE]);
		console.log(Bout.STAT_ENCOUNTER_NORMAL, Bout.that.data.statistics[Bout.STAT_ENCOUNTER_NORMAL]);
		console.log(Bout.STAT_TORCHES, Bout.that.data.statistics[Bout.STAT_TORCHES]);
		console.log(Bout.STAT_TORCHES_TOTAL, Bout.that.data.statistics[Bout.STAT_TORCHES_TOTAL]);
		console.log(Bout.STAT_CHESTS_TOTAL, Bout.that.data.statistics[Bout.STAT_CHESTS_TOTAL]);
		console.log(Bout.STAT_CHESTS_OPENED, Bout.that.data.statistics[Bout.STAT_CHESTS_OPENED]);
	}


	normalizeItemPool() {
		for (let x = 0; x < this.items.length; x++) {
			this.items.bound = false;
			this.items.droppable = true;
			this.items.worn = false;
		}
	}


	fillInventoryFromSave(a) {
		for (let x = 0; x < a.length; x++) {
			let item = this.createItem(a[x]);
			this.data.inventory.push(item);
		}

	}
	fillPaperdollFromSave(a) {
		for (let x = 0; x < a.length; x++) {
			let item = this.createItem(a[x]);
			this.data.paperdoll.push(item);
		}

	}

	restorePlayerStats() {
		this.player = new Player(this.savegame.state.player);
	}

	setPlayerStats() {
		this.player = new Player(Player.STARTING_STATS);
	}


	/*	getItemsFromSave() {
			let ret = [];
			let a = this.savegame.state.inventory.slice().concat(this.savegame.state.paperdoll.slice());
			for (let x = 0; x < a.length; x++) {
				let item = this.createItem(a[x]);
				ret.push(item);
			}
			return ret;
		}*/

	getStartingItems() {
		let ret = [];
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].startItem) {
				let item = this.createItem(a[x]);
				if (a[x].stackable) {
					item.stacked = a[x].startQuantity;
					ret.push(item);
				} else {
					if (a[x].startQuantity > 1) {
						ret.push(item);
						for (let y = 1; y < a[x].startQuantity; y++) {
							item = this.createItem(a[x]);
							ret.push(item);
						}

					} else {
						ret.push(item);
					}

				}




			}
		}
		return ret;
	}

	createItem(o) {
		let item = new ItemIniter()
		for (let prop in o) {
			item[prop] = o[prop];
		}
		if (!item.template_id) {
			item.template_id = item.id;
			item.id = item.id + "_" + Bout.ENUM++;
		}
		// aggiorna comunque rownew e colnew e tutta una serie di proprietà
		let ref = this.getItemFromTemplate(item.template_id);
		let toUpdate = ItemIniter.alwaysUpdate();
		for (let x = 0; x < toUpdate.length; x++) {
			item[toUpdate[x]] = ref[toUpdate[x]];
		}

		return new Item(item);
	}

	getItemFromTemplate(template_id) {
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === template_id) {
				return a[x];
			}
		}
		return null;
	}

	createItemFromTemplate(template_id) {
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === template_id) {
				//if (a[x].template_id === template_id) {
				return this.createItem(a[x]);
			}
		}
		return null;
	}


	fillInventoryFromStart(a) {
		for (let x = 0; x < a.length; x++) {
			if (!a[x].worn) {
				this.data.inventory.push(a[x]);
			}
		}


	}

	fillPaperdollFromStart(a) {
		for (let x = 0; x < a.length; x++) {
			if (a[x].worn) {
				this.data.paperdoll.push(a[x]);
			}
		}
	}


	getSaveState() {
		return this.data;
	}

	getInventory() {
		return this.data.inventory;
	}
	getPaperdoll() {
		return this.data.paperdoll;
	}

	removeFromInventory(item) {
		let a = this.data.inventory;
		let pos = -1;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === item.id) {
				pos = x;
				break;
			}
		}
		if (pos != -1) {
			this.data.inventory.splice(pos, 1);
		}

	}

	updateInventory(inventory) {
		this.data.inventory.splice(0, this.data.inventory.length);
		let a = inventory.getItemsSlots();
		for (let x = 0; x < a.length; x++) {
			if (a[x].hasItem()) {
				this.data.inventory.push(a[x].getItem());
			}
		}
	}
	updatePaperdoll(paperdoll) {
		this.data.paperdoll.splice(0, this.data.paperdoll.length);
		let a = paperdoll.getItemsSlots();
		for (let x = 0; x < a.length; x++) {
			if (a[x].hasItem()) {
				this.data.paperdoll.push(a[x].getItem());
			}
		}
	}


	getSkillsBonuses() {
		let ret = new Object();
		for (let x = 0; x < this.data.paperdoll.length; x++) {
			let item = this.data.paperdoll[x];
			if (item.bonus_skill > 0) {
				//ret.push({ id: item.player_skill, value: item.bonus_skill });
				if (!ret[item.player_skill]) {
					ret[item.player_skill] = item.bonus_skill;
				} else {
					ret[item.player_skill] = ret[item.player_skill] + item.bonus_skill;
				}
			}
		}
		return ret;
	}

	/*
	updateLevelChests(paperdoll) {
		for (let y = 0; y < this.levelChests.length; y++) {
			let o = this.levelChests[]
			this.data.paperdoll.splice(0, this.data.inventory.length);
			let a = paperdoll.getItemsSlots();
			for (let x = 0; x < a.length; x++) {
				if (a[x].hasItem()) {
					this.data.paperdoll.push(a[x].getItem());
				}
			}
		}

	}
	*/
	updateLevelChest(chestContent) {
		let chest = this.getChest(chestContent.chestId);
		chest.items.splice(0, chest.items.length);
		let a = chestContent.getItemsSlots();
		for (let x = 0; x < a.length; x++) {
			if (a[x].hasItem()) {
				chest.items.push(a[x].getItem());
			}
		}
	}

	getChest(idChest) {
		for (let x = 0; x < this.levelChests.length; x++) {
			if (this.levelChests[x].id === idChest) {
				return this.levelChests[x];
			}
		}
		return null;
	}



	resetLeveChests() {
		this.levelChests = new Array();
	}

	getChestItems(idChest, lLoot = false, index = -1) {
		if (!this.chestContentAlreadyCreated(idChest)) {
			this.createChestContent(idChest, lLoot, index);
			if (!lLoot) {
				Bout.incStatistic(Bout.STAT_CHESTS_OPENED, 1);
				Bout.incStatistic(Bout.STAT_SCORE, Game.SCORE_CHEST_OPENED);
			}
		}

		for (let x = 0; x < this.levelChests.length; x++) {
			if (this.levelChests[x].id === idChest) {
				return this.levelChests[x].items;
			}
		}
		return null
	}

	chestContentAlreadyCreated(idChest) {
		let a = this.levelChests;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === idChest) {
				return true;
			}
		}
		return false;
	}

	createChestContent(idChest, lLoot = false, index = -1) {
		//console.log("TO DO - CHEST/LOOT CONTENT")
		if (lLoot) {
			this.createLootContent(idChest, index);
		} else {
			this.createNormalChestContent(idChest, index);

			/*			let o = { id: idChest }
						o.items = new Array();
						o.items.push(this.getPotion())
						o.items.push(this.getMoney())
						o.items.push(this.getPendant())
						this.levelChests.push(o);*/
		}
	}
	/*
	getPotion() {
		// fatto a cazzo solo per provare
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].type === ItemProviders.TYPE_CONSUMABLES_POTIONS) {
				return this.createItem(a[x]);
			}
		}
		return null;
	}
	getMoney() {
		// fatto a cazzo solo per provare
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === "moneys_1_4") {
				return this.createItem(a[x]);
			}
		}
		return null;
	}
	getPendant() {
		// fatto a cazzo solo per provare
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === "necklaces_2_8") {
				return this.createItem(a[x]);
			}
		}
		return null;
	}*/

	/*createItemById(id) {
		let a = this.items;
		for (let x = 0; x < a.length; x++) {
			if (a[x].id === id) {
				return this.createItem(a[x]);
			}
		}
		return null;
	}*/

	createNormalChestContent(idChest, chestIndex) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let content = det.chestsContent.split(",")[chestIndex];
		content = Pqp.safeReplace(content, "[", "");
		content = Pqp.safeReplace(content, "]", "");
		content = content.split("|");

		let o = { id: idChest }
		o.items = new Array();

		for (let x = 0; x < content.length; x++) {
			let tmp = this.createNewItem(content[x]);
			for (let y = 0; y < tmp.length; y++) {
				o.items.push(tmp[y])
			}
		}
		this.levelChests.push(o);
	}



	createLootContent(idChest, stackIndex) {
		let det = Game.that.featurer.getCurrentLevelDetails();
		let loot = det.loot.split(",")[stackIndex];
		loot = Pqp.safeReplace(loot, "[", "");
		loot = Pqp.safeReplace(loot, "]", "");
		loot = loot.split("|");

		let o = { id: idChest }
		o.items = new Array();

		for (let x = 0; x < loot.length; x++) {
			let tmp = this.createNewItem(loot[x]);
			for (let y = 0; y < tmp.length; y++) {
				o.items.push(tmp[y])
			}
		}
		this.levelChests.push(o);
	}

	groupContains(s, t) {
		let a = s.split(",");
		for (let x = 0; x < a.length; x++) {
			if (jQuery.trim(a[x]) === t) {
				return true;
			}
		}
		return false;
	}
	createNewItem(loot) {
		let ret = new Array();
		let a = this.items;
		let group = jQuery.trim(loot.split(" ")[0]);
		let quantity = parseInt(loot.split(" ")[1]);

		let found = new Array();
		//console.log(loot,group)
		for (let x = 0; x < a.length; x++) {
			//console.log(a[x].group.indexOf(group));
			//if (a[x].group.indexOf(group) >= 0) {
			if (this.groupContains(a[x].group, group)) {
				found.push(a[x])
			}
		}



		//console.log(found)
		let item = this.createItem(this.getOne(found, group));
		ret.push(item);
		if (item.stackable) {
			item.stacked = quantity;
		} else {
			for (let y = 1; y < quantity; y++) {
				let item = this.createItem(this.getOne(found, group));
				ret.push(item);
			}
		}

		return ret;
	}

	getOne(a, group) {
		if (group.indexOf("best_") >= 0) {
			let skill_sword = Bout.that.player.getSkillValue(Skills.SKILL_SWORDSMANSHIP);
			let skill_mace = Bout.that.player.getSkillValue(Skills.SKILL_MACECOMBAT);
			let skill_fence = Bout.that.player.getSkillValue(Skills.SKILL_FENCING);
			let max = Math.max(skill_sword, skill_mace, skill_fence);
			if (max === skill_sword) {
				for (let x = 0; x < a.length; x++) {
					if (a[x].weapon_skill === Skills.SKILL_SWORDSMANSHIP) {
						return a[x];
					}
				}
			} else if (max === skill_mace) {
				for (let x = 0; x < a.length; x++) {
					if (a[x].weapon_skill === Skills.SKILL_MACECOMBAT) {
						return a[x];
					}
				}
			} else {
				for (let x = 0; x < a.length; x++) {
					if (a[x].weapon_skill === Skills.SKILL_FENCING) {
						return a[x];
					}
				}
			}
		}

		return a[Pqp.rnd(a.length - 1)];
	}


}
Bout.that = null;
Bout.ENUM = 0;

Bout.STAT_START_TIME = "statStartTime";
Bout.STAT_END_TIME = "statEndTime";

Bout.STAT_HERO_DEATHS = "statHeroDeaths";
Bout.STAT_SCORE = "statScore";
Bout.STAT_ENEMIES_KILLED = "statEnemiesKilled";

Bout.STAT_FIGHTS = "statFights";
Bout.STAT_ENCOUNTER_NORMAL = "statHeroNormal";
Bout.STAT_ENCOUNTER_AMBUSH = "statHeroAmbush";
Bout.STAT_ENCOUNTER_SURPRISE = "statHeroSurprise";


Bout.STAT_ATTACKS = "statAttacks";
Bout.STAT_HITS = "statHits";
Bout.STAT_HITS_CRITICAL = "statHitsCritical";

Bout.STAT_TOTAL_DAMAGE = "statTotalDamage";
Bout.STAT_MAX_DAMAGE = "statMaxDamage";

Bout.STAT_DAMAGE_SUFFERED = "statDamageSuffered";
Bout.STAT_SPIKE_DAMAGE = "spikeDamage"
Bout.STAT_PARRIED = "statParried";



Bout.STAT_TORCHES = "statTorches";
Bout.STAT_TORCHES_TOTAL = "statTorchesTotal";
Bout.STAT_CHESTS_TOTAL = "statChestsTotal";
Bout.STAT_CHESTS_OPENED = "statChestsOpened";
Bout.STAT_SECRETS_TOTAL = "statSecretsTotal";
Bout.STAT_SECRETS_DISCOVERED = "statSecretsDiscovered";
